import { message } from 'antd';
import { resolveError } from '../formatters/error/resolve-error';

export interface IHandleError {
  isLoading: boolean;
  hasError: boolean;
  /**
   * Is falsy if `hasError` is true
   */
  error?: Error | null | undefined;
}

export const handleError = (
  state: IHandleError,
  { error }: { error: any },
  label = 'NO LABEL'
) => {
  state.isLoading = false;
  state.hasError = true;
  state.error = error;
  message.error(`${label}: ${resolveError(error).message}`.slice(0, 200));
  console.error(`${label}:`, error);
};

export const handlePending = (state: { isLoading: boolean }) => {
  state.isLoading = true;
};
